import React, { FC } from 'react';
import { Box, Button, Typography } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import theme from '../../constants/theme';

const backButtonStyles = {
  background: 'none',
  display: 'inline-flex',
  ':hover': {
    backgroundColor: theme.colors.disableBg,
  },
  '&:focus': {
    backgroundColor: theme.colors.disableBg,
    outline: `2px solid ${theme.colors.borderGrey}`,
  },
  borderRadius: 1,
  cursor: 'pointer',
  alignItems: 'center',
  marginBottom: 1,
  padding: 1,
  border: 'none',
  color: '#000',
  transition: 'all ease',
};

interface BackBtnCompProps {
  handleOnClick: () => void;
  btnTitle?: string;
}

const BackBtnComp: FC<BackBtnCompProps> = ({ handleOnClick, btnTitle = 'Back' }) => {
  return (
    <Button sx={backButtonStyles} onClick={handleOnClick} aria-label="Go back">
      <Box display="flex" alignItems="center">
        <ArrowBackIosIcon sx={{ margin: 0, fontSize: 18 }} />
      </Box>
      <Typography>{btnTitle}</Typography>
    </Button>
  );
};

export default BackBtnComp;
